import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * RequireOnboarding: route-element gate (Phase 10, GAP 2).
 *
 * Always renders inside ProtectedRoute, which is the sole init gate; by the
 * time this component mounts, the auth context has finished initialising and
 * `user` is non-null. A user whose `persona_settings` is still empty
 * (`onboarded === false`) is redirected into the questionnaire at
 * /app/onboarding. An onboarded user passes straight through to the wrapped
 * AppLayout routes.
 */
export function RequireOnboarding() {
  const { user } = useAuth();
  const location = useLocation();

  if (user && !user.onboarded && location.pathname !== '/app/onboarding') {
    return <Navigate to="/app/onboarding" replace />;
  }

  return <Outlet />;
}
